import React, { useState } from "react";
import {
  View,
  Text,
  Image,
  Dimensions,
  Animated,
  TouchableOpacity,
  StyleSheet,
  ScrollView,
  FlatList,
  TextInput,
} from "react-native";
import Header from "../../component/header";
import Background from "../../component/background";
import FinalEntryAdd from "../../component/finalEntryAdd";
import { FontAwesome, Entypo, Ionicons } from "@expo/vector-icons";
const { width, height } = Dimensions.get("window");
export default function index({ navigation, route }) {
  console.log("route.params >>> ", route.params);
  return (
    <View style={styles.container}>
      <Header
        onPressHome={() => {
          navigation.navigate("HomeUser");
        }}
        onPressCompetition={() => {
          navigation.navigate("CompetitionUser");
        }}
        onPressAthlete={() => {
          navigation.navigate("AthleteUser");
        }}
        onPressLogout={() => {
          navigation.navigate("Login");
        }}
        backgroundColorCompetition="#FFFFFF"
        User
        navigation={navigation}
      />
      <ScrollView>
        <View>
          <Background
            navigation={navigation}
            Title={`COMPETITIONS/${route.params.name}/FINAL ENTRY SUBMIT`}
          />
          <FinalEntryAdd route={route} navigation={navigation} />
        </View>
      </ScrollView>
    </View>
  );
}
const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: "#CCE4FF",
    flexDirection: "row",
  },
});
